import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CRMIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.1191 33.3844C23.4528 32.8913 22.8451 32.3152 22.3121 31.6657C21.0172 30.0879 20.233 28.1619 20.0508 26.1428L30.1529 26.1427C30.6563 26.1424 31.0642 25.7343 31.0642 25.2309C31.0642 23.1705 30.5318 21.1326 29.5028 19.321C28.6751 17.8636 27.5569 16.6074 26.23 15.6224C27.2036 15.3011 28.2443 15.1272 29.3257 15.1272C34.7769 15.1272 39.1959 19.5463 39.1959 24.9975C39.1959 30.4487 34.7769 34.8677 29.3257 34.8677C27.4147 34.8677 25.6305 34.3246 24.1191 33.3844Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.87793 25.2303C8.87793 19.6285 13.4191 15.0874 19.0208 15.0874C20.8485 15.0874 22.5608 15.57 24.0401 16.4142C24.0569 16.4254 24.0741 16.4362 24.0918 16.4463C25.6464 17.3439 26.9437 18.6434 27.8397 20.2208C28.5597 21.4884 28.9928 22.8867 29.122 24.3186H19.0204C18.5168 24.3186 18.1087 24.7268 18.1087 25.2304C18.1087 27.9988 19.0686 30.6817 20.8249 32.8218C21.3919 33.5127 22.0306 34.1332 22.727 34.675C21.5796 35.1256 20.3298 35.3732 19.0208 35.3732C13.4191 35.3732 8.87793 30.8321 8.87793 25.2303Z",
                fill: "white"
            })
        ]
    });
